/** Set when a sign-in succeeds, read once by the welcome dialog. */
export const WELCOME_BACK_KEY = "compasscare.welcomeBack";

export function markWelcomeBack() {
  try {
    sessionStorage.setItem(WELCOME_BACK_KEY, "1");
  } catch (_err) {
    // A private-mode storage failure must not block the signed-in landing.
  }
}

export function readWelcomeBack() {
  try {
    return sessionStorage.getItem(WELCOME_BACK_KEY) === "1";
  } catch (_err) {
    return false;
  }
}

export function clearWelcomeBack() {
  try {
    sessionStorage.removeItem(WELCOME_BACK_KEY);
  } catch (_err) {
    // ignore
  }
}
